import { Box, Typography } from "@mui/material";
import { ReactComponent as Check } from "../../assets/icons/cart_icons/Check.svg";
import { ReactComponent as OrderEdit } from "../../assets/icons/order_icon/orderedit_icon.svg";
import { ReactComponent as CrossIcon } from "../../assets/icons/order_icon/whitecross_icon.svg";
import { useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../context/GlobalContext";

const OrderComplete = () => {
  const { setOrderComplete } = useGlobalContext();
  const orderDetails = JSON.parse(localStorage.getItem("response"));

  const navigate = useNavigate();

  const handleCrossClick = () => {
    setOrderComplete(false);
    localStorage.removeItem("response");
    navigate("/home");
  };

  const handleEditClick = () => {
    setOrderComplete(false);
    navigate("/order");
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "450px",
          display: "flex",
          alignItems: "center",
          marginTop: "3vw",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        <div
          style={{ width: "100%", textAlign: "right" }}
          onClick={() => handleCrossClick()}
        >
          <CrossIcon style={{ cursor: "pointer" }} />
        </div>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "1vw",
            marginTop: "2vw",
          }}
        >
          <span
            style={{
              fontFamily: "Poppins",
              fontWeight: 500,
              fontSize: "1.1vw",
              lineHeight: "100%",
            }}
          >
            #{orderDetails?.orderNo}
          </span>
          <Check />
          <Typography
            fontFamily={"Poppins"}
            fontSize={"1.1vw"}
            fontWeight={"500"}
          >
            Order Placed!
          </Typography>
          <Typography
            fontFamily={"Poppins"}
            fontSize={"14px"}
            fontWeight={"500"}
          >
            Thanks for purchasing from Binny’s.
          </Typography>
          {/* <Box
            style={{ display: "flex", gap: "5px", cursor: "pointer" }}
            onClick={() => handleEditClick()}
          >
            <OrderEdit />
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "14px",
                fontWeight: 500,
                color: "#50C878",
                textDecoration: "underline",
              }}
            >
              Edit Order
            </Typography>
          </Box> */}
        </Box>
      </Box>
    </Box>
  );
};

export default OrderComplete;
